export const injectDataCy = (
  dataCy?: string
): object | { "data-cy": string } => {
  return dataCy ? { "data-cy": dataCy } : {};
};
